
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

export const useAuthContext = () => { 
    const context = useContext(AuthContext)

    if (!context) {
        throw Error(
            "useWorkoutsContext must be used within a WorkoutsContextProvider"
        )
    }
    return context
}